// src/App.tsx
import React, { useState } from 'react';
import { ConfigProvider, Layout } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ComingSoon from './pages/ComingSoon';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import CommunityGuidelines from './components/CommunityGuidelines';
import { darkTheme, lightTheme } from './theme';
import Footer from './components/Footer'; // add this at the top
import Shop from './pages/Shop';



const App: React.FC = () => {
  const [darkMode, setDarkMode] = useState(true);
  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ConfigProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Layout style={{ minHeight: '100vh', background: darkMode ? '#000' : '#fff' }}>
          <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
          <Layout.Content>
            <Routes>
              <Route path="/" element={<ComingSoon />} />
              <Route path="/termsandconditions" element={<TermsAndConditions />} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/communityguidelines" element={<CommunityGuidelines />} />
              <Route path="/shop" element={<Shop />} />
            </Routes>
          </Layout.Content>
          <Footer darkMode={darkMode} />
        </Layout>
      </Router>
    </ConfigProvider>
  );
};

export default App;
